import { ExtractionDisplayStatus, ExtractionStatus } from '../types';

/**
 * The status shown to the reseller for each raw status the service reports. Both the status a row
 * displays and the statuses its filter sends are derived from this table, so the two cannot drift.
 */
const DISPLAY_STATUS_BY_RAW_STATUS: Record<string, ExtractionDisplayStatus> = {
    [ExtractionStatus.PROCESSING]: 'PROCESSING',
    [ExtractionStatus.EXTRACTED]: 'PROCESSING',
    [ExtractionStatus.DRAFT]: 'DRAFT',
    [ExtractionStatus.CREATED]: 'CREATED',
    [ExtractionStatus.TRANSACTION_SUBMITTED]: 'CREATED',
    [ExtractionStatus.FAILED]: 'FAILED',
    [ExtractionStatus.DISCARDED]: 'DISCARDED',
};

export const EXTRACTION_DISPLAY_STATUSES: ExtractionDisplayStatus[] = [
    'PROCESSING',
    'DRAFT',
    'CREATED',
    'FAILED',
    'DISCARDED',
];

/** The statuses the dashboard shows when the reseller selects none: discarded drafts only appear when asked for. */
export const DEFAULT_EXTRACTION_DISPLAY_STATUSES: ExtractionDisplayStatus[] = EXTRACTION_DISPLAY_STATUSES.filter(
    (status) => status !== 'DISCARDED'
);

/**
 * Collapses a raw extraction status into the status shown to the reseller. Status is an open string,
 * so a value this build does not know about is still in flight and reads as PROCESSING.
 */
export const toDisplayStatus = (status?: string): ExtractionDisplayStatus =>
    DISPLAY_STATUS_BY_RAW_STATUS[(status || '').toUpperCase()] || 'PROCESSING';

/** Expands the selected dashboard statuses into the raw statuses the service filters on. */
export const toStatusFilter = (displayStatuses: string[]): string[] | undefined => {
    if (!displayStatuses.length) return undefined;
    return Object.keys(DISPLAY_STATUS_BY_RAW_STATUS).filter((rawStatus) =>
        displayStatuses.includes(DISPLAY_STATUS_BY_RAW_STATUS[rawStatus])
    );
};
